import { createContext } from 'react';

const AppContext = createContext({
  toggleFullscreen: () => {},
  slotAnimationTargetRef: null,
  slotCrystalTargetRef: null,
  slotFSTargetRef: null,
  slotBalanceRef: null,
  slotOverlayRef: null,
  isRegistered: false,
  setIsRegistered: () => {},
  slotBalance: 1000,
  setSlotBalance: () => {},
  crystalCount: 0,
  setCrystalCount: () => {},
});
export default AppContext;